// Module
var code = "<div class=\"property-container\"> <span data-bind=\"text: Name\"></span> <select data-bind=\"options: Options, optionsText: 'Name', value: Value, enableAttr: IsEnabled()\" class=\"form-control\"></select> </div>";
// Exports
export default code;